module.exports = __webpack_public_path__ + "img/bbc-radio-5-live.e63244e5.png";